/**
 * TODO
 * WIP
 */
import React from 'react';

import { css, cx } from '@emotion/css';
import { UseHoverProps } from '@floating-ui/react';
import { Theme, Typography } from '@mui/material';

import { useStyles } from '@/hooks/useStyles';
import {
  BaseTooltip,
  BaseTooltipProps,
} from '@/uiKit/atoms/floating/BaseTooltip.tsx';
import { Optional } from '@/utils/commonUtils';

export type TooltipProps = Omit<Optional<BaseTooltipProps, 'role'>, 'type'> & {
  hover?: UseHoverProps;
};

/**
 * TODO refactor tooltip to be more maintainable
 */
export const Tooltip: React.FC<TooltipProps> = ({
  role = 'tooltip',
  hover,
  className,
  floaterClassName,
  wrapperClassName,
  children,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <BaseTooltip
      type={hover ? { type: 'hover', ...hover } : 'hover'}
      role={role}
      className={cx(styles.container, className)}
      wrapperClassName={cx(styles.wrapper, wrapperClassName)}
      floaterClassName={cx(styles.floater, floaterClassName)}
      {...props}
    >
      {children}
    </BaseTooltip>
  );
};

export type TextTooltipProps = Omit<TooltipProps, 'content'> & {
  text: string | undefined;
};

/**
 * TODO refactor tooltip to be more maintainable
 */
export const TextTooltip: React.FC<TextTooltipProps> = ({
  text,
  children,
  ...props
}) => (
  <Tooltip
    content={<Typography variant="bodySmall">{text}</Typography>}
    {...props}
  >
    {children}
  </Tooltip>
);

const makeStyles = (theme: Theme) => ({
  container: css``,
  wrapper: css``,
  floater: css`
    padding: ${theme.spacing(4)};
  `,
});
